module.exports = __webpack_public_path__ + "static/media/gdpr-all-about-cover-en.caa62562.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ebook/gdpr-all-about-cover-en.jpg
// module id = 552
// module chunks = 0